import { useState } from "react";
import { IAvailableEquipment } from "@store/Equipments/actionTypes";
import { makeNotifs } from "@utils/makeNotifs";
import { useGlobalNotifs } from "@utils/hooks/useGlobalNotifs";
import { DRAGGING_TYPES3 } from "@mobx/store/locations/types";
import mainLocationsStore from "@mobx/store/locations";

type DragEventType = React.DragEvent<HTMLDivElement>;
export const temporaryRackPrefix = "#temporary";

const useDrag = () => {
  const { onSuccess } = useGlobalNotifs();
  const { ok } = makeNotifs();
  const locationStore = mainLocationsStore.activeLocation;
  const buildingStore = locationStore?.activeBuilding;

  const [showDraggingOverlay, setShowDraggingOverlay] =
    useState<boolean>(false);
  const [draggingLastTemplate, setDraggingLastTemplate] =
    useState<boolean>(false);

  const onNewRackSaved = () => {
    setShowDraggingOverlay(false);
    setDraggingLastTemplate(false);
  };

  const onAvailableDraging = (e: DragEventType) => {
    const type = e.dataTransfer.items[0]?.type;
    if (type === DRAGGING_TYPES3.AVAILABLE_EQUIPMENT) {
      setShowDraggingOverlay(true);
    }
  };

  const onDragOverRackTable = (e: DragEventType) => {
    e.preventDefault();
  };

  const onRackTemplateLeave = () => {
    setDraggingLastTemplate(false);
  };

  const onOverlayLeave = (e: DragEventType) => {
    setShowDraggingOverlay(false);
  };

  const addNewEquipment = async (e: DragEventType) => {
    if (!showDraggingOverlay || !buildingStore)
      return setShowDraggingOverlay(false);

    const _: IAvailableEquipment = JSON.parse(
      e.dataTransfer.getData(DRAGGING_TYPES3.AVAILABLE_EQUIPMENT)
    );

    // TODO: add equipment ?

    buildingStore?.setCanUndo();
    setShowDraggingOverlay(false);
    onSuccess(ok.success);
  };

  const onDropEquipment = (e: DragEventType) => {
    addNewEquipment(e);
    setShowDraggingOverlay(false);
  };

  const onDrop = (e: DragEventType) => {
    e.preventDefault();
    const type = e.dataTransfer.items[0]?.type as DRAGGING_TYPES3;

    switch (type) {
      case DRAGGING_TYPES3.AVAILABLE_EQUIPMENT:
        onDropEquipment(e);
        break;
      case DRAGGING_TYPES3.AVAILABLE_RACK:
        break;
    }
  };

  return {
    draggingLastTemplate,
    showDraggingOverlay,

    onRackTemplateLeave,
    onDragOverRackTable,
    onNewRackSaved,
    onOverlayLeave,
    onAvailableDraging,
    onDrop,
  };
};

export default useDrag;
